import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import {
    required,
    email,
    minLength,
    maxLength,
    numeric
} from "vuelidate/lib/validators";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "applicantUpdate",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            isEditForm: true,
            applicant: {
                name: "",
                email: "",
                phone_number: "",
                address: "",
                gender: "",
                id: ""
            },
            error_email: "",
            submitted: false
        };
    },

    validations: {
        applicant: {
            name: {
                required,
                maxLength: maxLength(100)
            },
            email: {
                required,
                email,
                maxLength: maxLength(100)
            },
            phone_number: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(11),
                numeric
            },
            address: {
                required,
                maxLength: maxLength(200)
            },
            gender: {
                required
            }
        }
    },

    methods: {
        onPhoneInput(e) {
            const val = e.target.value.replace(/[^0-9၀၁၂၃၄၅၆၇၈၉]/g, '').replace(/(\..*)\./g, '$1');
            this.applicant.phone_number = val;
            e.target.value = val;
        },

        handleSubmit() {
            this.submitted = true;
            this.error_email = "";
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.updateApplicant();
        },

        showApplicantUpdate() {
            axios.get("/applicant/update/" + this.$route.params.id)
                .then(response => {
                    this.applicant = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        updateApplicant() {
            this.isLoading = true;
            var request = {
                id: this.applicant.id,
                name: this.applicant.name,
                email: this.applicant.email,
                phone_number: this.applicant.phone_number,
                address: this.applicant.address,
                gender: this.applicant.gender
            };
            axios.post("/applicant/updated", request)
                .then(response=> {
                    if (response.data.msg) {
                        this.error_email = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.isLoading = false;
                        this.$notification.success("အချက်အလက်များ ပြောင်းလဲခြင်း အောင်မြင်သည်။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        setTimeout(() => this.$router.push({
                            name: "applicantIndex"
                        }), 2000);
                        // location.reload();
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log(error);
                });
        }
    },

    created() {
        this.showApplicantUpdate();
    }
};